import React from 'react'
import './assets/global/css/line-awesome.min.css';
import './assets/admin/css/app.css';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';
import HomeMain from './Components/Layouts/HomeMain';
import Home from './Components/Home/Home';
import Staff from './Components/Pages/Staff/Staff';
import StaffAdd from './Components/Pages/Staff/StaffAdd';
import StaffEdit from './Components/Pages/Staff/StaffEdit';
import StaffDetails from './Components/Pages/Staff/StaffDetails';
import Login from './Components/Auth/Login';
import Reset from './Components/Auth/Reset';
import LoginRoute from './Route/LoginRoute';
import ReSetPassword from './Components/Auth/ReSetPassword';

import StaffDetailsByEmail from './Components/Pages/Staff/StaffDetailsByEmail';
import StaffLoginInfo from './Components/Pages/Staff/StaffLoginInfo/StaffLoginInfo';
import Profile from './Components/Pages/Admin/Profile/Profile';
import Password from './Components/Pages/Admin/Password/Password';
import DepositMethodsView from './Components/Pages/DepositMethods/DepositMethodsView';
import DepositMethodsAdd from './Components/Pages/DepositMethods/DepositMethodsAdd';
import DepositMethodsEdit from './Components/Pages/DepositMethods/DepositMethodsEdit';
import DepositMethodsDragAndDrop from './Components/Pages/DepositMethods/DepositMethodsDragAndDrop/DepositMethodsDragAndDrop';
import AllDeposits from './Components/Pages/Deposits/AllDeposits/AllDeposits';
import ApprovedDeposits from './Components/Pages/Deposits/ApprovedDeposits/ApprovedDeposits';
import RejectDeposits from './Components/Pages/Deposits/RejectDeposits/RejectDeposits';
import PendingDeposits from './Components/Pages/Deposits/PendingDeposits/PendingDeposits';
import DepositsDetails from './Components/Pages/Deposits/DepositsDetails/DepositsDetails';
import WithdrawalMethods from './Components/Pages/Withdrawal/WithdrawalMethods/WithdrawalMethods';
import WithdrawalMethodsEdit from './Components/Pages/Withdrawal/WithdrawalMethods/WithdrawalMethodsEdit';
import PendingWithdrawals from './Components/Pages/Withdrawal/PendingWithdrawals/PendingWithdrawals';
import ApprovedWithdrawals from './Components/Pages/Withdrawal/ApprovedWithdrawals/ApprovedWithdrawals';
import RejectedWithdrawals from './Components/Pages/Withdrawal/RejectedWithdrawals/RejectedWithdrawals';
import WithdrawalsLog from './Components/Pages/Withdrawal/WithdrawalsLog/WithdrawalsLog';
import WithdrawalsDetails from './Components/Pages/Withdrawal/WithdrawalsDetails/WithdrawalsDetails';
import PlatformTypeView from './Components/Pages/PlatformType/PlatformTypeView/PlatformTypeView';
import PlatformTypeAdd from './Components/Pages/PlatformType/PlatformTypeAdd/PlatformTypeAdd';
import PlatformTypeEdit from './Components/Pages/PlatformType/PlatformTypeEdit/PlatformTypeEdit';
import PlatformRulesView from './Components/Pages/PlatformRules/PlatformRulesView/PlatformRulesView';
import PlatformRulesAdd from './Components/Pages/PlatformRules/PlatformRulesAdd/PlatformRulesAdd';
import PlatformRulesEdit from './Components/Pages/PlatformRules/PlatformRulesEdit/PlatformRulesEdit';
import ProductView from './Components/Pages/Product/ProductView/ProductView';
import ProductAdd from './Components/Pages/Product/ProductAdd/ProductAdd';
import ProductEdit from './Components/Pages/Product/ProductEdit/ProductEdit';
import MiningView from './Components/Pages/Mining/MiningView';
import MiningAdd from './Components/Pages/Mining/MiningAdd';
import MiningEdit from './Components/Pages/Mining/MiningEdit';
import AllMining from './Components/Pages/Mining/AllMining/AllMining';
import ExpriedMining from './Components/Pages/Mining/ExpriedMining/ExpriedMining';
import GoldMiningDragAndDrop from './Components/Pages/Mining/MiningDragAndDrop/GoldMiningDragAndDrop/GoldMiningDragAndDrop';
import GoldMiningMessage from './Components/Pages/Mining/Message/GoldMiningMessage';
import OrderSetView from './Components/Pages/OrderSet/OrderSetView/OrderSetView';
import OrderSetEdit from './Components/Pages/OrderSet/OrderSetEdit/OrderSetEdit';
import ActiveUsers from './Components/Pages/Users/ActiveUsers/ActiveUsers';
import BannedUsers from './Components/Pages/Users/BannedUsers/BannedUsers';
import EmailUnverifiedUsers from './Components/Pages/Users/EmailUnverifiedUsers/EmailUnverifiedUsers';
import MobileUnverified from './Components/Pages/Users/MobileUnverified/MobileUnverified';
import KYCUnverifiedUsers from './Components/Pages/Users/KYCUnverifiedUsers/KYCUnverifiedUsers';
import KYCPendingUsers from './Components/Pages/Users/KYCPendingUsers/KYCPendingUsers';
import UsersWithBalance from './Components/Pages/Users/UsersWithBalance/UsersWithBalance';
import AllUsers from './Components/Pages/Users/AllUsers/AllUsers';
import UserDetails from './Components/Pages/Users/UserDetails/UserDetails';
import Orders from './Components/Pages/Orders/Orders';
import UserLoginHistory from './Components/Pages/Users/History/UserLoginHistory/UserLoginHistory';
import KYCData from './Components/Pages/Users/KYCData/KYCData';
import UserRunningMining from './Components/Pages/UserMining/UserRunningMining';
import UserCompleteMining from './Components/Pages/UserMining/UserCompleteMining';
import UserAllMining from './Components/Pages/UserMining/UserAllMining';
import AgentHomeMain from './Components/AgentAccount/Layouts/AgentHomeMain';
import AgentHome from './Components/AgentAccount/Layouts/AgentHome/AgentHome';
import AgentActiveUsers from './Components/AgentAccount/pages/Users/ActiveUsers/ActiveUsers';
import AgentAllUsers from './Components/AgentAccount/pages/Users/AllUsers/AllUsers';
import AgentBannedUsers from './Components/AgentAccount/pages/Users/BannedUsers/BannedUsers';
import AgentAllDeposits from './Components/AgentAccount/pages/Deposits/AllDeposits/AllDeposits';
import AgentApprovedDeposits from './Components/AgentAccount/pages/Deposits/ApprovedDeposits/ApprovedDeposits';
import AgentPendingDeposits from './Components/AgentAccount/pages/Deposits/PendingDeposits/PendingDeposits';
import AgentRejectDeposits from './Components/AgentAccount/pages/Deposits/RejectDeposits/RejectDeposits';
import AgentUserDetails from './Components/AgentAccount/pages/Users/UserDetails/UserDetails';
import AgentAllWithdrawals from './Components/AgentAccount/pages/Withdrawals/AllWithdrawals/AllWithdrawals';
import AgentApprovedWithdrawals from './Components/AgentAccount/pages/Withdrawals/ApprovedWithdrawals/ApprovedWithdrawals';
import AgentPendingWithdrawals from './Components/AgentAccount/pages/Withdrawals/PendingWithdrawals/PendingWithdrawals';
import AgentRejectWithdrawals from './Components/AgentAccount/pages/Withdrawals/RejectWithdrawals/RejectWithdrawals';
import AgentWithdrawalsDetails from './Components/AgentAccount/pages/Withdrawals/WithdrawalsDetails/WithdrawalsDetails';
import AgentDepositsDetails from './Components/AgentAccount/pages/Deposits/DepositsDetails/DepositsDetails';
import AgentTransactionLogs from './Components/AgentAccount/pages/TransactionLogs/TransactionLogs';
import Notices from './Components/Pages/Notices/Notices';
import NoticesAdd from './Components/Pages/Notices/NoticesAdd';
import NoticesEdit from './Components/Pages/Notices/NoticesEdit';


function App() {

  return (
    <BrowserRouter>
      {/* <ScrollToTop />  */}
      <Routes>
        <Route path="/admin" element={<HomeMain />}>
          <Route path="dashboard" element={<Home />} />

          <Route path="staff/login/info/:id" element={<StaffLoginInfo />} />
          <Route path="staff" element={<Staff />} />
          <Route path="staff/add" element={<StaffAdd />} />
          <Route path="staff/edit/:id" element={<StaffEdit />} />
          <Route path="staff/details/:id" element={<StaffDetails />} />
          <Route path="staff/details/by/email/:email" element={<StaffDetailsByEmail />} />

          {/* admin deposit methods */}
          <Route path="deposit/method" element={<DepositMethodsView />} />
          <Route path="deposit/method/add" element={<DepositMethodsAdd />} />
          <Route path="deposit/method/edit/:id" element={<DepositMethodsEdit />} />
          <Route path="deposit/method/active" element={<DepositMethodsDragAndDrop />} />

          {/* admin deposit view */}
          <Route path="deposit" element={<AllDeposits />} />
          <Route path="deposit/pending" element={<PendingDeposits />} />
          <Route path="deposit/approved" element={<ApprovedDeposits />} />
          <Route path="deposit/rejected" element={<RejectDeposits />} />
          <Route path="deposit/details/:id" element={<DepositsDetails />} />

          {/* admin withdrawal view */}
          <Route path="withdraw/method" element={<WithdrawalMethods />} />
          <Route path="withdraw/method/edit/:id" element={<WithdrawalMethodsEdit />} />
          <Route path="withdraw/pending" element={<PendingWithdrawals />} />
          <Route path="withdraw/approved" element={<ApprovedWithdrawals />} />
          <Route path="withdraw/rejected" element={<RejectedWithdrawals />} />
          <Route path="withdraw/log" element={<WithdrawalsLog />} />
          <Route path="withdraw/details/:id" element={<WithdrawalsDetails />} />

          {/* Platform Type */}
          <Route path="platform-type/view" element={<PlatformTypeView />} />
          <Route path="platform-type/store" element={<PlatformTypeAdd />} />
          <Route path="platform-type/edit/:id" element={<PlatformTypeEdit />} />

          {/* Platform rules */}
          <Route path="platform-rules/view" element={<PlatformRulesView />} />
          <Route path="platform-rules/store" element={<PlatformRulesAdd />} />
          <Route path="platform-rules/edit/:id" element={<PlatformRulesEdit />} />

          {/* product */}
          <Route path="product/view" element={<ProductView />} />
          <Route path="product/store" element={<ProductAdd />} />
          <Route path="product/edit/:id" element={<ProductEdit />} />


          {/* mining  */}
          <Route path="running/mining/view" element={<MiningView />} />
          <Route path="mining/add" element={<MiningAdd />} />
          <Route path="mining/edit/:id" element={<MiningEdit />} />
          <Route path="all/mining/view" element={<AllMining />} />
          <Route path="expired/mining/view" element={<ExpriedMining />} />
          <Route path="active/gold/mining/view" element={<GoldMiningDragAndDrop />} />
          <Route path="gold/mining/message" element={<GoldMiningMessage />} />


          {/* order-set */}
          <Route path="order-set" element={<OrderSetView />} />
          <Route path="order-set/edit/:id" element={<OrderSetEdit />} />


          {/* users */}
          <Route path="users/active" element={<ActiveUsers />} />
          <Route path="users/banned" element={<BannedUsers />} />
          <Route path="users/email-unverified" element={<EmailUnverifiedUsers />} />
          <Route path="users/mobile-unverified" element={<MobileUnverified />} />
          <Route path="users/kyc-unverified" element={<KYCUnverifiedUsers />} />
          <Route path="users/kyc-pending" element={<KYCPendingUsers />} />
          <Route path="users/with-balance" element={<UsersWithBalance />} />
          <Route path="users/all" element={<AllUsers />} />
          <Route path="user/details/:id" element={<UserDetails />} />
          <Route path="report/login/history/:id" element={<UserLoginHistory />} />
          <Route path="users/kyc-data/:id" element={<KYCData />} />



          {/* user mining  */}
          <Route path="user/running/mining/view" element={<UserRunningMining />} />
          <Route path="user/complete/mining/view" element={<UserCompleteMining />} />
          <Route path="user/all/mining/view" element={<UserAllMining />} />




          {/* order */}
          <Route path="order" element={<Orders />} />
          <Route path="notices/view" element={<Notices />} />
          <Route path="notices/store" element={<NoticesAdd />} />
          <Route path="notices/edit/:id" element={<NoticesEdit />} />

          <Route path="profile" element={<Profile />} />
          <Route path="password" element={<Password />} />

        </Route>

        <Route path="/agent" element={<AgentHomeMain />}>
          <Route path="dashboard" element={<AgentHome />} />

          {/* user  */}
          <Route path="all/users" element={<AgentAllUsers />} />
          <Route path="active/users" element={<AgentActiveUsers />} />
          <Route path="banned/users" element={<AgentBannedUsers />} />
          <Route path="user/details/:id" element={<AgentUserDetails />} />

          {/* deposit  */}
          <Route path="all/deposits" element={<AgentAllDeposits />} />
          <Route path="approved/deposits" element={<AgentApprovedDeposits />} />
          <Route path="pending/deposits" element={<AgentPendingDeposits />} />
          <Route path="reject/deposits" element={<AgentRejectDeposits />} />
          <Route path="deposit/detail/:id" element={<AgentDepositsDetails />} />

          {/* deposit  */}
          <Route path="all/withdraws" element={<AgentAllWithdrawals />} />
          <Route path="approved/withdraws" element={<AgentApprovedWithdrawals />} />
          <Route path="pending/withdraws" element={<AgentPendingWithdrawals />} />
          <Route path="reject/withdraws" element={<AgentRejectWithdrawals />} />
          <Route path="withdraw/detail/:id" element={<AgentWithdrawalsDetails />} />


          <Route path="transaction/logs" element={<AgentTransactionLogs />} />

        </Route>


        <Route path="/" element={<LoginRoute><Login /></LoginRoute>} />
        <Route path="/admin/password/reset" element={<LoginRoute><Reset /></LoginRoute>} />
        <Route path="/reset/password/:id/:token" element={<LoginRoute> <ReSetPassword /> </LoginRoute>} />
      </Routes>

    </BrowserRouter>


  );
}

export default App;